module.exports = __webpack_public_path__ + "static/media/history.802506a3.jpg";